// Shared in-memory cache of object URLs keyed by file path, so navigating
// back to a folder (or switching views) doesn't re-fetch already-seen files.
const cache = new Map();

export function getCachedUrl(key) {
  return cache.get(key);
}

export function setCachedUrl(key, url) {
  cache.set(key, url);
}

export function hasCachedUrl(key) {
  return cache.has(key);
}
